import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setTitle('Lieferant')
        .setChildren([
            MenuEntry.create()
                .setRoute('supplier_search')
                .setAdditionalRoutes([
                    'supplier',
                ]),
        ]),
];
